var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path0, _path1, _rect3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSazoneWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sazone-white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.685,
    height: 119.407,
    viewBox: "0 0 258.685 119.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27157",
    "data-name": "Trazado 27157",
    d: "M344.036,271.451c-.008,1.83-1.339,2.93-3.526,2.921l-2.309-.009-.011,2.714-.909,0,.035-8.6,3.217.013c2.187.009,3.508,1.119,3.5,2.961m-.909,0c.006-1.375-.9-2.165-2.619-2.172l-2.284-.009-.017,4.3,2.284.009c1.719.007,2.633-.775,2.637-2.126",
    transform: "translate(-198.691 -158.16)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27158",
    "data-name": "Trazado 27158",
    d: "M360.833,274.9l-4.789-.02L355,277.171l-.946,0,3.965-8.58.9,0,3.894,8.613-.958,0Zm-.328-.738-2.044-4.626-2.082,4.609Z",
    transform: "translate(-208.575 -158.224)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27159",
    "data-name": "Trazado 27159",
    d: "M376.846,276.106l.357-.7a4.222,4.222,0,0,0,2.836,1.055c1.607.007,2.311-.666,2.315-1.513.01-2.358-5.289-.93-5.276-4.111.005-1.265.992-2.354,3.178-2.345a4.853,4.853,0,0,1,2.662.772l-.312.723a4.427,4.427,0,0,0-2.355-.722c-1.572-.006-2.276.691-2.276,1.55-.009,2.358,5.289.956,5.276,4.087,0,1.265-1.017,2.341-3.213,2.333a4.661,4.661,0,0,1-3.189-1.13",
    transform: "translate(-221.999 -158.169)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_359",
    "data-name": "Rect\\xE1ngulo 359",
    width: 8.596,
    height: 0.909,
    transform: "translate(163.221 119.015) rotate(-89.767)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27160",
    "data-name": "Trazado 27160",
    d: "M404.44,269.9a4.515,4.515,0,1,1,4.5,4.39,4.326,4.326,0,0,1-4.5-4.39m8.117.034a3.611,3.611,0,1,0-3.615,3.547,3.481,3.481,0,0,0,3.615-3.547M409.87,263.4l1.167,0-2,1.513-.86,0Z",
    transform: "translate(-238.256 -155.168)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27161",
    "data-name": "Trazado 27161",
    d: "M438.55,268.891l-.035,8.6-.749,0-5.5-7-.029,6.975-.909,0,.035-8.6.749,0,5.51,7,.029-6.975Z",
    transform: "translate(-254.096 -158.385)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27162",
    "data-name": "Trazado 27162",
    d: "M461.656,273.2a4.316,4.316,0,0,1,4.525-4.353,4.161,4.161,0,0,1,3.139,1.265l-.58.575a3.407,3.407,0,0,0-2.538-1.03,3.562,3.562,0,1,0-.029,7.124,3.37,3.37,0,0,0,2.546-1.022l.575.58a4.18,4.18,0,0,1-3.161,1.252,4.313,4.313,0,0,1-4.477-4.39",
    transform: "translate(-271.96 -158.378)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27163",
    "data-name": "Trazado 27163",
    d: "M484.759,274.006l.02-4.924.909,0-.02,4.887c-.009,2.039.946,2.976,2.616,2.983s2.644-.922,2.652-2.961l.02-4.888.885,0-.02,4.924c-.01,2.468-1.342,3.74-3.54,3.731s-3.532-1.292-3.521-3.76",
    transform: "translate(-285.57 -158.516)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27164",
    "data-name": "Trazado 27164",
    d: "M508.614,269.181l.909,0-.032,7.81,4.815.02,0,.785-5.723-.023Z",
    transform: "translate(-299.603 -158.575)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_360",
    "data-name": "Rect\\xE1ngulo 360",
    width: 8.596,
    height: 0.909,
    transform: "translate(216.211 119.232) rotate(-89.767)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27165",
    "data-name": "Trazado 27165",
    d: "M542.432,269.321l-.035,8.6-.749,0-5.5-7-.028,6.975-.909,0,.035-8.6.749,0,5.51,7,.028-6.975Z",
    transform: "translate(-315.293 -158.64)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27166",
    "data-name": "Trazado 27166",
    d: "M562.945,275.727l-4.789-.02L557.115,278l-.946,0,3.965-8.58.9,0,3.895,8.613-.958,0Zm-.329-.738-2.044-4.626-2.082,4.609Z",
    transform: "translate(-327.637 -158.712)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27167",
    "data-name": "Trazado 27167",
    d: "M585.727,275.146a2.664,2.664,0,0,0,1.976-2.694c.008-1.842-1.314-2.953-3.5-2.961l-3.217-.013-.035,8.6.908,0,.011-2.726,2.309.009a6.214,6.214,0,0,0,.688-.034l1.953,2.771.995,0Zm-1.57-.559-2.284-.009.017-4.31,2.285.009c1.719.007,2.625.8,2.619,2.172-.005,1.351-.918,2.145-2.637,2.138",
    transform: "translate(-342.236 -158.749)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_361",
    "data-name": "Rect\\xE1ngulo 361",
    width: 8.596,
    height: 0.909,
    transform: "translate(247.595 119.361) rotate(-89.767)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27168",
    "data-name": "Trazado 27168",
    d: "M613.1,269.634l-.9,0-3.965,8.58.946,0,1.041-2.293,4.789.02,1.023,2.3.958,0Zm-2.54,5.553,2.081-4.609,2.045,4.626Z",
    transform: "translate(-358.315 -158.838)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27169",
    "data-name": "Trazado 27169",
    d: "M42.235,154.45a30.694,30.694,0,1,1,31.011-30.374A30.694,30.694,0,0,1,42.235,154.45m.606-58.372a27.683,27.683,0,1,0,27.394,27.968A27.683,27.683,0,0,0,42.84,96.078",
    transform: "translate(-6.985 -54.824)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27170",
    "data-name": "Trazado 27170",
    d: "M66.981,11.949a17.322,17.322,0,0,0-7.047-6.789c-4-1.928-9.05-2.428-13.057-.382A15.332,15.332,0,0,0,41.31,9.829c-2.977,4.215-2.368,9.767.029,14.131,2.412,4.664,6.543,7.877,10.6,11.135a70.781,70.781,0,0,1,8.438,7.479,58.326,58.326,0,0,1,7.845,10.848A36.34,36.34,0,0,1,71.595,78c-6.739,27.542-38.2,37.8-59.783,19.319A33.578,33.578,0,0,1,2.3,59.456C6.046,49.127,14.71,41.236,24.863,37.421q-1.813.86-3.545,1.861c-7.969,4.6-14.508,11.935-17.26,20.783C-.169,72.858,3.417,86.311,13.876,94.91c9.687,8.249,24.14,10.711,35.731,5.225a34.792,34.792,0,0,0,18.4-22.954,33.686,33.686,0,0,0-2.829-22.169,55.432,55.432,0,0,0-7.23-10.337c-5.891-6.81-14.778-11.18-18.806-19.6-1.855-3.789-2.689-8.367-1.332-12.493a16.144,16.144,0,0,1,8.443-9.112,14.167,14.167,0,0,1,8.211-.942,16.725,16.725,0,0,1,12.513,9.427",
    transform: "translate(0.001 -1.349)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27171",
    "data-name": "Trazado 27171",
    d: "M44.652,122.184c-5.952,3.669-9.474,10.391-10.314,17.181-.96,6.844,2.053,13.555,7.236,18.071a22.565,22.565,0,0,0,12.451,5.623,20.047,20.047,0,0,1-13.4-4.478,20.537,20.537,0,0,1-8.078-19.451c1.065-7.056,5.327-14.181,12.1-16.948",
    transform: "translate(-19.023 -71.977)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27172",
    "data-name": "Trazado 27172",
    d: "M77.571,172.69a16.9,16.9,0,0,0,18.357-2.067,15.433,15.433,0,0,0,4.662-8.265,16.151,16.151,0,0,0-.793-9.711,14.266,14.266,0,0,1,1.89,9.914,15.376,15.376,0,0,1-4.813,9.133c-5.2,4.452-13.832,5.311-19.3,1",
    transform: "translate(-45.696 -89.924)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27173",
    "data-name": "Trazado 27173",
    d: "M79.8,58.36a13.77,13.77,0,0,0-5.864-7.676A30.631,30.631,0,0,1,71.2,48.637a7.277,7.277,0,0,1-2.753-4.373c-.59-3.33-1.116-6.67-1.68-10q-1.085-6.406-2.191-12.81c-.619-3.694-1.226-7.39-1.86-11.082-.407-2.375-.782-4.76-1.308-7.11A4.18,4.18,0,0,0,56.991.03a4.055,4.055,0,0,0-3.13,3.976,8.676,8.676,0,0,0,.317,2.215q5.161,19.253,10.366,38.5a7.161,7.161,0,0,1-.429,5.138c-.735,1.523-1.574,3-2.392,4.479A12.018,12.018,0,0,0,60.116,60.4c0,.223.014.446.023.667a7.88,7.88,0,0,1,7.934.4c4.9,2.867,9.365,1.29,12.376-.689-.183-.806-.4-1.611-.644-2.414M61.612,14.884c-.105-.469-.167-.937-.255-1.4a70.429,70.429,0,0,0-2.261-9.6,19.022,19.022,0,0,1,2.517,11M76.2,57.828a11.153,11.153,0,0,0-5.9-6.27,7.887,7.887,0,0,1,6.177,6.185,11.91,11.91,0,0,1,.174,1.294c-.17-.4-.288-.816-.452-1.21",
    transform: "translate(-31.728 0)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27174",
    "data-name": "Trazado 27174",
    d: "M212.274,160.59c-4.558-4.3-10.9-6.94-16.948-4.373-7.283,3.16-12.966,13.408-12.662,21.226.27,9.127,6.891,14.932,15.316,9.314a27.126,27.126,0,0,0,11.279-17.226c.519-3.481,1.059-7.237,1.713-10.691l-.017.233v-.054s-.005-.021.022.1a1.31,1.31,0,0,0,2.475.12,103.762,103.762,0,0,0,.506,15.843,46.806,46.806,0,0,0,3.447,14.143c.27.611.7,1.263,1,1.849-5.776-7.364-7.4-21.363-7.575-30.593l.007-1.08a2.8,2.8,0,0,1,.188-1.231,1.366,1.366,0,0,1,2.584.659c0,.071.015.22.016.284l-.022.158c-.428,3.156-.816,6.714-1.184,9.9a29.748,29.748,0,0,1-9.7,18.349A18.825,18.825,0,0,1,193,192.38c-5.333.84-10.37-2.951-12.169-7.765a19.3,19.3,0,0,1-1.3-7.124,24.819,24.819,0,0,1,4.137-13.331c7.02-11.535,19.364-14.519,28.613-3.57",
    transform: "translate(-105.754 -90.583)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27175",
    "data-name": "Trazado 27175",
    d: "M269.472,159.836c7.96-3.734,21.2-8.122,29.732-4.755a10.582,10.582,0,0,1,3.933,2.718,3.854,3.854,0,0,1,1.059,3.649,8.665,8.665,0,0,1-2.045,3.517,43.611,43.611,0,0,1-5.063,4.714c-3.432,2.824-6.966,5.462-10.335,8.315a57.988,57.988,0,0,0-8.032,7.915c-.625.831-1.644,1.994-1.466,3.035.2.543,1,.924,1.647,1.142,4.065,1.189,8.518.872,12.745.7,4.4-.241,8.811-.725,13.23-1.242-7.168,2.024-19.585,4.9-26.776,3.146-3.674-.948-4.823-3.95-2.887-7.14a25.409,25.409,0,0,1,2.074-2.909c3.587-4.408,8.054-8.081,12.413-11.538,2.892-2.321,7.542-5.693,10-8.316a6.394,6.394,0,0,0,1.421-2.092.632.632,0,0,0,.014-.469,9.249,9.249,0,0,0-5.931-3.461c-8.193-1.54-17.742.874-25.735,3.075",
    transform: "translate(-158.746 -90.65)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27176",
    "data-name": "Trazado 27176",
    d: "M376.193,155.388c-6.623,2.6-12.568,8.1-13.979,15.262a20.546,20.546,0,0,0,1.89,13.456,14.527,14.527,0,0,0,10.679,7.166c8.93,1.579,18.783-4.172,20.892-13.153,2.266-9.435-5.87-18.356-14.614-20.674a15.874,15.874,0,0,0-7.243-.236,15.051,15.051,0,0,1,7.433-.717,22.083,22.083,0,0,1,13.178,7.389c12.589,14.716-2.821,33.926-20.241,30.8-5.315-.921-10.448-4.171-12.813-9.137a22.174,22.174,0,0,1-1.386-15.42c2.02-7.494,8.775-13.067,16.2-14.73",
    transform: "translate(-211.607 -91.539)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27177",
    "data-name": "Trazado 27177",
    d: "M461.539,156.057c1.469,9.883,2.461,19.825,3.224,29.786q.365,4.984.6,9.982h-2.884c0-.977.021-3.31.017-4.244-.085-9.327-1.549-26.207,6.529-32.6a14.062,14.062,0,0,1,15.385-.661c5.225,3.532,7.383,10.076,7.9,16.073.478,7.676-.774,15.313-1.785,22.894-.5-6.636-.174-13.248-.777-19.856-.391-6.025-1.931-12.755-7.1-16.289-4-2.41-10.482-1.57-13.1,2.295-4.471,6.649-3.838,18.783-3.972,26.723,0,1.655-.126,4.073-.2,5.739h-2.884c-.033-3.312-.073-6.628-.145-9.945-.109-6.694-.61-22.983-.791-29.9",
    transform: "translate(-271.891 -91.932)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27178",
    "data-name": "Trazado 27178",
    d: "M546.393,185.213c4.271-2.25,8.568-4.537,12.741-6.93a33.393,33.393,0,0,0,5.749-4.055c2.245-2.025,4.578-4.933,3.826-8.109-.618-2.4-2.958-4.055-5.3-4.647a12.664,12.664,0,0,0-12.64,4.895c-3.36,4.493-4.219,10.487-3.408,15.961a13.764,13.764,0,0,0,10.4,11.52c4.56,1.2,9.338.495,13.808-.886a54.634,54.634,0,0,0,6.7-2.71c-6.895,4.834-16.475,8.261-24.728,4.706-6.426-2.742-9.643-9.143-9.784-15.908-.4-7.769,2.98-16.546,10.507-19.814,4.928-2.255,11.553-1.942,15.326,2.361,4.392,4.971,1.351,11.055-3.236,14.384a42.183,42.183,0,0,1-9.77,5.287c-3.347,1.428-6.735,2.784-10.187,3.943",
    transform: "translate(-320.306 -92.991)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSazoneWhite);
export default __webpack_public_path__ + "static/media/sazone-white.502f3692f96e33a938af1eefdcec301e.svg";
export { ForwardRef as ReactComponent };